export default "https://cdn-static.gokick.com/assets/78cedee4a9b459fbef408ae219aa3203e6c5e731/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";